import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_ACTIVE, LB_CODE, LB_NAME, LB_TYPE, LB_UDN} from "../../../components/i18n/i18n";
import {PH_CODE, PH_NAME} from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {udnProvider} from "../../../providers/udnProvider";
import {afiClassProvider} from "../../../providers/afiClassProvider";
import {FL_ONLY_REGISTERED} from "../../../components/i18n/formLabels";

const AfiFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}

    const [status, setStatus] = useState(filter?.status || null);
    const [udn, setUdn] = useState(filter?.udn?.id || null);
    const [afiClass, setAfiClass] = useState(filter?.afiClass?.id || null);
    const [onlyRegistered, setOnlyRegistered] = useState(!props.generalPropouse || true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            name: filter?.name || '',
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            onlyRegistered,
            item : {  ...data, }
        };

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        if (udn !== undefined && udn !== null)
            dataFilter.item.udn = {id: udn};

        if (afiClass !== undefined && afiClass !== null)
            dataFilter.item.afiClass = {id: afiClass};

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        setUdn(null)
        setAfiClass(null)
        reset({
            name: '',
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{LB_NAME}</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder={PH_NAME}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <SelectGeneric
                            title={LB_UDN}
                            initialValue={udn}
                            provider={udnProvider}
                            setExternalValue={setUdn}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <SelectGeneric
                            title={LB_TYPE}
                            initialValue={afiClass}
                            provider={afiClassProvider}
                            setExternalValue={setAfiClass}
                        />
                    </FormGroup>
                </Col>

                <Col md="3">
                    <FormGroup>
                        <Label>{LB_ACTIVE}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                {
                    app?.fbDataBase !== undefined && <Col md="3">
                        <FormGroup>
                            <Label>{ FL_ONLY_REGISTERED }</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                }
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(AfiFilters)